<template>
  <v-container fluid class="pa-4">
    <v-card class="rounded-lg">
      <v-card-title class="d-flex justify-space-between align-center pa-4">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-file</v-icon>
          <h2 class="font-weight-bold">계약서 조회</h2>
        </div>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-card class="h-100">
              <v-card-title class="d-flex align-center">
                <v-icon start color="primary" class="mr-2">mdi-file-document-outline</v-icon>
                시설계약서
              </v-card-title>
              <v-card-text class="pa-0">
                <div class="pdf-container">
                  <iframe v-if="pdfUrls.comp" :src="pdfUrls.comp" width="100%" height="1200" frameborder="0"></iframe>
                  <v-sheet v-else class="d-flex align-center justify-center" height="1200">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-sheet>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="6">
            <v-card class="h-100">
              <v-card-title class="d-flex align-center">
                <v-icon start color="primary" class="mr-2">mdi-file-document-outline</v-icon>
                자동이체 이용 신청서
              </v-card-title>
              <v-card-text class="pa-0">
                <div class="pdf-container">
                  <iframe v-if="pdfUrls.cms" :src="pdfUrls.cms" width="100%" height="1200" frameborder="0"></iframe>
                  <v-sheet v-else class="d-flex align-center justify-center" height="1200">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-sheet>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
const store = useStore();
import axios from "axios";
import { ref, reactive, onMounted } from "vue";

interface PdfUrls {
  comp: string | null;
  cms: string | null;
}

interface Loading {
  comp: boolean;
  cms: boolean;
}

const pdfUrls = ref<PdfUrls>({
  comp: null,
  cms: null
});

const loading = reactive<Loading>({
  comp: false,
  cms: false
});

const code = ref<string>('');
const form = reactive({
  send_name: "",
  send_rel_depo: "",
  send_phone: "",
  cms_playing_agree: true,
  cms_policy_agree: true,
  sisul_name: "",
  sisul_num: "",
  sisul_tell: "",
  cms_apply_gubun: "신규",
  recv_comp_name: "㈜함우리",
  recv_comp_boss: "김승식",
  recv_comp_addr: "전북특별자치도 전주시 덕진구 기지로77",
  recv_comp_biz_num: "185-81-02287",
  recv_bank_history: "업무위탁 수임료",
  recv_day: "매월 25일",
  payment_method: "계좌",
  bank_owner: "",
  bank_owner_birth: "",
  bank_name: "",
  send_biz_num: "",
  bank_num: "",
  bank_owner_phone: "",
  cms_contract_day: "2025-04-02",
});

const createPdfUrl = (pdfBase64: string) => {
  const binaryString = window.atob(pdfBase64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: "application/pdf" });
  return window.URL.createObjectURL(blob);
};

const getCompContract = async () => {
  try {
    loading.comp = true;
    const response = await axios.post(`/api/getCompContract/${code.value}`,
      { responseType: "json" }
    );
    pdfUrls.value.comp = createPdfUrl(response.data.pdf);
  } catch (error) {
    console.error("시설계약서 PDF 미리보기 중 에러 발생:", error);
  } finally {
    loading.comp = false;
  }
};

const getCMSContract = async () => {
  try {
    loading.cms = true;
    const level = 0;
    const response = await axios.post(
      `/api/getCMSContract/${level}`,
      { form: form },
      { responseType: "json" }
    );
    pdfUrls.value.cms = createPdfUrl(response.data.pdf);
  } catch (error) {
    console.error("자동이체 이용 신청서 PDF 미리보기 중 에러 발생:", error);
  } finally {
    loading.cms = false;
  }
};

onMounted(async () => {
  code.value = store.state.AdminSisulCode;
  await Promise.all([getCompContract(), getCMSContract()]);
});
</script>

<style scoped>
.pdf-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 1200px;
  background-color: #f5f5f5;
}

.pdf-container iframe {
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
